(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCompare(scope) {
    var roots = (scope || document).querySelectorAll('.compare:not([data-compare-init])');
    roots.forEach(function (root) {
      root.setAttribute('data-compare-init', 'true');
      var btn = root.querySelector('.compare__toggle');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = root.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = btn.querySelector('.compare__toggle-label');
        if (label) {
          label.textContent = open ? label.dataset.collapse : label.dataset.expand;
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    initCompare();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initCompare(); });
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initCompare(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
